export const version = "hash/5.6.1";
//# sourceMappingURL=_version.js.map